/**
 * @module tree/body
 */

import defaults from '../selectors/defaults.js'

/**
 *
 * @param {String} innerHTML
 * @param {Document} document
 * @returns {HTMLBodyElement}
 */
export default (
  innerHTML = '',
  document = defaults.document
) => {
  return Object.assign(document.createElement('body'), {
    innerHTML
  })
}
